import Vue from 'vue';

export default {
  state: {
    // 当前关注的学生信息（可能是登录 或 注册）
    targetStudent: {}
  },
  actions: {
    ['CLASS_GET_TARGET_STUDENT']({ commit }, { secret, studentId, type }) {
      // 面向教师端分享页的注册
      const TYPE_TEACHER_SHARE = 1;
      // 面向学生端注册邀请：
      const TYPE_REGISTER_TASK = 2;
      if (type === TYPE_TEACHER_SHARE) {
        /**
         * 获取班级学生列表(主要含账户绑定情况)
         * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=137921145#hfs-wechat%E7%8F%AD%E7%BA%A7API-%E8%8E%B7%E5%8F%96%E7%8F%AD%E7%BA%A7%E5%AD%A6%E7%94%9F%E5%88%97%E8%A1%A8
        */
        return Vue.http.get('/v1/classes/students', {params: { secret }})
        .then(resp => Vue.checkResp(resp))
        .then(data => {
          if (data) {
            const targetStudent = data.students.find(s => s.id === studentId);
            commit('CLASS_SET_TARGET_STUDENT', targetStudent);
          }
        })
      } else if (type === TYPE_REGISTER_TASK){
        /**
         * 根据加密邀请信息获取学生基本信息
         * http://wiki.iyunxiao.com/pages/viewpage.action?pageId=147260976#id-%E5%AD%A6%E7%94%9F%E4%BF%A1%E6%81%AFAPI-V2-%E6%A0%B9%E6%8D%AE%E5%8A%A0%E5%AF%86%E9%82%80%E8%AF%B7%E4%BF%A1%E6%81%AF%E8%8E%B7%E5%8F%96%E5%AD%A6%E7%94%9F%E5%9F%BA%E6%9C%AC%E4%BF%A1%E6%81%AF
         */
        return Vue.http.get(
          '/v1/be-proxy/v2/mapi/students/basic-info',
          {params: { secret }})
        .then(resp => Vue.checkResp(resp))
        .then(data => {
          commit('CLASS_SET_TARGET_STUDENT', data)
        })
      } else return console.log('类型错误')
    }
  },
  mutations: {
    ['CLASS_SET_TARGET_STUDENT'](state, payload) {
      state.targetStudent = payload || {};
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/ReportApp/store/modules/modules_classes.js